<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard" [ngClass]="hide ? 'responsiveHide-column' : 'responsiveShow-column'">
        <p-toast key="toastmsg"></p-toast>
        <div class="mainDivHeader">
            <div class="leftdiv">
                <h4>Find a Partner - Chat History</h4>
            </div>
        </div>

        <div class="mainDivBody">
            <div class="chat-history-container" *ngIf="conversationId">
                <!-- Chat Header Bar -->
                <div class="chat-header-bar">
                    <div class="chat-info">
                        <i class="pi pi-comments"></i>
                        <h5>Conversation History</h5>
                    </div>
                </div>

                <!-- Loading State -->
                <div *ngIf="loading" class="loading-wrapper">
                    <i class="pi pi-spin pi-spinner"></i>
                    <span>Loading messages...</span>
                </div>

                <!-- Chat Feed -->
                <div class="chat-feed" *ngIf="!loading">
                    <div class="chat-table-wrapper">
                        <div *ngIf="messagesList?.length === 0" class="empty-chat-message">
                            <i class="pi pi-comments"></i>
                            <span>No chat history messages found.</span>
                        </div>

                        <div *ngFor="let message of messagesList" class="chat-message-item">
                            <!-- Avatar -->
                            <img *ngIf="message.senderId?.profilepic; else initialsAvatar"
                                [src]="message.senderId.profilepic" class="user-avatar" alt="Avatar" />
                            <ng-template #initialsAvatar>
                                <div class="user-avatar"
                                    [style.backgroundColor]="getAvatarColor(message.senderId?.firstName + ' ' + message.senderId?.lastName)">
                                    {{ getInitials(message.senderId?.firstName, message.senderId?.lastName) }}
                                </div>
                            </ng-template>

                            <!-- Content -->
                            <div class="message-content-wrapper">
                                <div class="message-meta">
                                    <span class="sender-name">
                                        {{ message.senderId?.firstName }} {{ message.senderId?.lastName }}
                                    </span>
                                    <span class="meta-dot"></span>
                                    <span class="message-time">
                                        {{ message.created_at | date: 'dd-MM-yyyy hh:mm a' }}
                                    </span>
                                </div>

                                <div class="message-body">
                                    <!-- Video -->
                                    <div *ngIf="isAttachment(message.content) && isVideo(message.content)"
                                        class="media-preview-container">
                                        <div class="media-wrapper">
                                            <video controls [src]="message.attachment?.url"></video>
                                        </div>
                                        <div class="media-label-bar">
                                            <span>{{ message.content }}</span>
                                            <a [href]="message.attachment?.url" target="_blank">View Full</a>
                                        </div>
                                    </div>

                                    <!-- Image -->
                                    <div *ngIf="isAttachment(message.content) && isImage(message.content)"
                                        class="media-preview-container">
                                        <div class="media-wrapper">
                                            <img [src]="message.attachment?.url" alt="Shared attachment" />
                                        </div>
                                        <div class="media-label-bar">
                                            <span>{{ message.content }}</span>
                                            <a [href]="message.attachment?.url" target="_blank">View Full</a>
                                        </div>
                                    </div>

                                    <!-- File -->
                                    <div *ngIf="isAttachment(message.content) && !isVideo(message.content) && !isImage(message.content)"
                                        class="attachment-card">
                                        <div class="file-info">
                                            <div class="file-icon">
                                                <i class="pi pi-file"></i>
                                            </div>
                                            <div class="file-details">
                                                <span class="file-name">{{ message.content }}</span>
                                                <span class="file-meta-label">File Attachment</span>
                                            </div>
                                        </div>
                                        <a class="download-action-btn" [href]="message.attachment?.url"
                                            target="_blank">
                                            <i class="pi pi-download"></i>
                                        </a>
                                    </div>

                                    <!-- Text -->
                                    <span *ngIf="!isAttachment(message.content)">
                                        {{ message.content }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="chat-pagination" *ngIf="totalRecords > 0">
                        <div class="pagination-summary">
                            In total there are {{ totalRecords }} messages.
                        </div>
                        <p-paginator [rows]="pageLimitFirst" [totalRecords]="totalRecords" pageLinkSize="3"
                            [showPageLinks]="true" [first]="(pageNumberFirst - 1) * pageLimitFirst"
                            (onPageChange)="loadChatHistory($event)"
                            [rowsPerPageOptions]="paginationOption"></p-paginator>
                    </div>
                </div>
            </div>

            <!-- No Conversation Found -->
            <div *ngIf="!conversationId && !loading" class="empty-chat-message">
                <i class="pi pi-comments"></i>
                <span>No conversation found between these players.</span>
            </div>
        </div>
    </div>
</div>
